export const educationData = [
  {
    id: 1,
    institution: "Sukkur IBA University",
    course: "BSCS (Software Engineering)",
    startYear: "2018",
    endYear: "2022",
  },
  {
    id: 2,
    institution: "Pakturk Marif International Schools and colleges, Lahore",
    course: "HSSC",
    startYear: "2015",
    endYear: "2017",
  },
  // {
  //     id: 3,
  //     institution: 'Army Public Schools and Colleges',
  //     course: 'SSC',
  //     startYear: '2013',
  //     endYear: '2015'
  // },
];
